<template>
  <div class="MultiOptionSelect">
    <div v-if="prompt" class="prompt">{{ prompt }}</div>
    <div
      class="options"
      :class="[
        optionIcons ? 'withIcons' : 'withoutIcons',
        options.length === 4 ? 'twoPerRow' : 'threePerRow',
      ]"
    >
      <OptionTile v-for="option in options"
        :key="option.value"
        v-bind="{ option, disabled, optionIcons }"
        :fieldName="name"
        :isSelected="value?.includes(option.value)"
        @change.stop="doEmitSelectionChanged"
        @input.stop
      />
    </div>
    <FieldError v-if="error !== null" v-bind="{ error }" class="error" />
  </div>
</template>

<script>
import FieldError from './FieldError.vue'
import OptionTile from './OptionTile.vue'

function arrayWithItemToggled(ary, item, includeItem) {
  const result = ary.filter(
    (aryItem) => aryItem !== item
  )
  if (includeItem) {
    result.push(item)
  }
  return result
}

export default {
  components: {
    FieldError,
    OptionTile,
  },
  props: {
    name: String,
    prompt: String,
    options: Array,
    value: Array,
    error: String,
    disabled: Boolean,
    optionIcons: Object,
  },
  methods: {
    doEmitSelectionChanged({ target }) {
      const newFieldValue = arrayWithItemToggled(this.value, target.value, target.checked)
      this.$emit('selectionChange', newFieldValue)
    },
  },
}
</script>

<style scoped>

.prompt {
  color: var(--text-color-dark);
  font-size: var(--font-size-1);
  font-weight: 500;
}

.options {
  margin-top: var(--spacing-2);
}

.options.withoutIcons {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.options.withIcons {
  display: grid;
  gap: var(--spacing-5);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (--screen-lg) {
  .options.withIcons.threePerRow {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .options.withIcons.twoPerRow {
    max-width: 26rem;
  }
}
</style>
